import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    padding: 0.75rem;
    justify-content: center;
    align-items: center;
    gap: 0.75rem;
    align-self: stretch;
    border-radius: 0.75rem;
    border: 1px solid var(--Green-Pix, #32bcad);

    button.copy-button {
        svg {
            width: 1.5rem;
            height: 1.5rem;
        }
    }
`;

export const Code = styled.span`
    color: var(--Neutral-900, #18181b);
    font-size: 1rem;
    font-weight: 500;
    overflow: hidden;

    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    width: 100%;
`;
